import {Friend, SocialBridge} from '../socialBridge';
import PresenceType from '../../constants/PresenceType';

const socialWeb: SocialBridge = {
    getFriendsList: async (): Promise<Friend[]> => [],
    getOnlineStatus: async (): Promise<PresenceType> => PresenceType.ONLINE,
    setStatusOnline: async (): Promise<void> => undefined,
    setStatusAway: async (): Promise<void> => undefined,
    openChat: async (): Promise<void> => undefined,
    hasThirdPartyAccounts: async (): Promise<boolean> => false,
    registerResponseCallback: async (): Promise<void> => undefined
};

export default socialWeb;
